import React from "react";
import styles from "./styles.module.scss";

/**
 * EarlyAccessButton组件 - 用于显示"Get Early Access"的按钮组件
 * @param onClick 点击按钮时触发的回调函数
 * @param style 可选的行内样式
 * @returns 渲染的按钮组件
 */
const EarlyAccessButton = ({ onClick, style }: { onClick?: () => void; style?: React.CSSProperties }) => {
  return (
    <>
      <button className={styles.earlyAccessButton} onClick={onClick} style={style}>
        Get Early Access
      </button>
    </>
  );
};

export default EarlyAccessButton;
